import { render, staticRenderFns } from "./ContactMessageSearch.vue?vue&type=template&id=8b840886&"
import script from "./ContactMessageSearch.vue?vue&type=script&lang=js&"
export * from "./ContactMessageSearch.vue?vue&type=script&lang=js&"
import style0 from "./ContactMessageSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports